// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__bNl0y","content":"styles_content__TWsTM"};